/*
 * Process-wide count of open kit overlays, so a host's document-level Escape
 * handler (Companion's Esc-Esc switch-user) can ignore a dismissing Escape.
 *
 * A plain count suffices: releases run in effect cleanups, and dialog
 * cancel/close and Popover light dismiss are default actions of the keydown,
 * so a handler reading this during that Escape still sees the closing overlay.
 */
let openCount = 0;

export const getOpenDismissableCount = (): number => openCount;

/**
 * Count one open overlay; release in the effect cleanup (idempotent).
 * `useDialog`/`usePopover` do this already; call it for a host's own popups.
 */
export function registerDismissable(): () => void {
  openCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    openCount -= 1;
  };
}
